const initQuantityInputButtons = () => {
	const $quantityInputs = $('.quantity-input').find('input[type="number"]').not('.buttons-active');

	$quantityInputs.each(function() {
		const quantityField = $(this);
		const decrementButton = $('<button class="decrement-button">-</button>');
		const incrementButton = $('<button class="increment-button">+</button>');

		quantityField.addClass('buttons-active');

		quantityField.before(decrementButton);
		quantityField.after(incrementButton);

		decrementButton.on('click', function(e) {
			e.preventDefault();

			const currentValue = Number(quantityField.val());

			if (currentValue > 1) {
				quantityField.val(currentValue - 1).change();
			}

			return false;
		});

		incrementButton.on('click', function(e) {
			e.preventDefault();

			quantityField.val(Number(quantityField.val()) + 1).change();

			return false;
		});
	});
};

export default initQuantityInputButtons;
